import { memo } from 'react';

interface TelephoneProperties {
    phoneNumber: string | undefined;
}

export const Telephone = memo((props: TelephoneProperties) => {
    const { phoneNumber } = props;
    return phoneNumber;
});
Telephone.displayName = 'Telephone';
